import React from "react"
import styled from "styled-components"

const Span = styled.span`
	display: block;
	width: 100%;
	height: 1px;
	background-color: black;
`
const Line = (props) => <Span {...props} />

export default Line
